<style></style>

<template>
  <div class="as-modal" :class="{ 'full-width': fullWidth }" v-if="show">
    <div class="modal-container">
      <div class="modal-head">
        <h3>Пользователи</h3>
        <div class="actions-block">
          <ul>
            <li>
              <a href="#" @click.prevent="fullView()" class="as-zoom">
                <font-awesome-icon
                  class="as-icon"
                  :icon="['fas', 'compress']"
                />
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="close()" class="as-close">x</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-body">
        <Datatable v-if="users" v-bind:type="`users`" />
        <p v-else class="text-center">Контент отсутствует!</p>
      </div>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/cockpit/users_td.vue";

export default {
  data() {
    return {
      show: false,
      fullWidth: false,
      users: []
    };
  },
  methods: {
    close() {
      this.show = false;
      document.body.classList.remove("modal-open");
    },
    fullView() {
      this.fullWidth = !this.fullWidth;
    }
  },
  components: {
    Datatable
  }
};
</script>
